import PrivateLayout from '../templates/PrivateLayout';
import { FaApple } from "react-icons/fa";
import { IoLogoGooglePlaystore } from "react-icons/io5";

const DownloadApp = () => {
  return (
    <PrivateLayout>
      <div className="flex flex-col items-center min-h-screen">
        <div className="w-full max-w-md p-8 bg-white rounded-lg">
          <h1 className="text-2xl font-semibold text-gray-800 mb-6 text-center">
            Baixe Agora Nosso App!
          </h1>

          <p className="text-md text-gray-600 mb-6 text-center">
            Explore todas as funcionalidades que oferecemos e tenha acesso a recursos exclusivos diretamente no seu celular.
          </p>

          <div className="text-center mb-6">
            <div className="flex flex-col items-center mt-4 space-y-4">
              <a
                target="_blank" rel="noopener noreferrer"
                href="https://play.google.com/store/apps/details?id=com.projetofono.fonotherapp"
                className="bg-green-600 text-white py-3 px-6 rounded-lg text-sm font-medium flex items-center justify-center gap-2 hover:bg-green-700 transition-colors duration-200"
              >
                <IoLogoGooglePlaystore className="text-lg" />
                Baixar na Play Store
              </a>
              <a
                target="_blank" rel="noopener noreferrer"
                href="https://apps.apple.com/br/app/fonotherapp/id6738363190"
                className="bg-black text-white py-3 px-6 rounded-lg text-sm font-medium flex items-center justify-center gap-2 hover:bg-gray-800 transition-colors duration-200"
              >
                <FaApple className="text-lg" />
                Baixar na App Store
              </a>
            </div>
          </div>
        </div>
      </div>
    </PrivateLayout>
  );
};

export default DownloadApp;
